import { jsx as _jsx } from "react/jsx-runtime";
import { Component, createRef } from 'react';

/**
 * Wraps any component with a class component with a focus method on it.
 * When the edit button on UIFloatingFormControl is clicked it calls the focus
 * method on its child component. This HoC provides a prop called inputRef for
 * its child that can be passed down to the underlying UIComponent.
 *
 * We have to do this because usually UIFloatingFormControl is placed directly
 * above an input but in our case there are a few layers of components between
 * the form control and the actual input so this HoC acts as a passthrough layer
 * to make sure the focus call makes it to the input component.
 */
const withFloatingFormControlFocus = WrappedComponent => {
  var _temp;

  return _temp = class ComponentWithFloatingFormControlFocus extends Component {
    constructor(props) {
      super(props);

      this.setPopoverOpen = popoverOpen => {
        this.setState({
          popoverOpen
        });
      };

      this.inputRef = /*#__PURE__*/createRef();
      this.popoverRef = /*#__PURE__*/createRef();
      this.state = {
        popoverOpen: false
      };
    }
    /**
     * This focus method is the "One True Focus Method". It is here to proxy
     * focus calls from form controls (specifically UIFloatingFormControl) down
     * to inputRef which is what's actually referencing the input being rendered
     *
     * To put this into a UI perspective, this is the focus method that gets
     * called when the edit button on UIFloatingFormControl is called.
     */


    focus() {
      const inputRef = this.getSafeRef();

      if (inputRef.current) {
        inputRef.current.focus(); // Since we don't have full typescript coverage here we have to check
        // that the ref has a select method. This is likely always true but
        // until we can be sure via typescript this guard will prevent
        // accidental JS errors.

        if (typeof inputRef.current.select === 'function') {
          inputRef.current.select();
        }
      }

      this.setState({
        popoverOpen: true
      });
    }

    getSafeRef() {
      return this.props.inputRef || this.inputRef;
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        inputRef: this.getSafeRef(),
        popoverOpen: this.state.popoverOpen,
        setPopoverOpen: this.setPopoverOpen
      }));
    }

  }, _temp;
};

export default withFloatingFormControlFocus;